function sfOppIsMobileNavContext(el) {
      return !!(el && el.closest && (
            el.closest('.mobile-nav') ||
                el.closest('#NavDrawer') ||
                    el.closest('[id*="NavDrawer"]') ||
                        el.closest('.drawer') ||
                            el.closest('.js-drawer-open-left') ||
                                el.closest('.mobile-nav-wrapper')
      ));
    }

    function sfOppFindToggle(link) {
          var item = link.closest('li') || link.parentElement;
            if (!item) return null;
              return item.querySelector('button.mobile-nav__toggle, button[aria-controls], .mobile-nav__toggle-button, button.collapsible-trigger, .js-toggle-submenu, button.mobile-nav__link-button') || item.querySelector('button');
    }

    function sfOppOnClick(e) {
          var link = e.target.closest && e.target.closest('a.Opportunities, a.mobile-nav__link.Opportunities, a.site-nav__link.Opportunities');
            if (!link) return;
              if (!sfOppIsMobileNavContext(link) && window.matchMedia && !window.matchMedia('(max-width: 989px)').matches) {
                    if (!link.closest('.mobile-nav, #NavDrawer, .drawer')) return;
              }
                if (!(sfOppIsMobileNavContext(link) || (window.matchMedia && window.matchMedia('(max-width: 989px)').matches))) return;
                  var toggle = sfOppFindToggle(link);
                    if (!toggle) return;
                      e.preventDefault();
                        e.stopPropagation();
                          toggle.click();
            }

            document.addEventListener('click', sfOppOnClick, true);
  
